// 2026-09-27 US-010
import { notification } from 'antd';
import { APIResponseCode, MessageDisplay } from 'common/constants';
import { GetNotificationProps } from 'common/utils/utility';
import { APIResponse, PostData } from 'common/utils/jsonFetch';
import { KFSEndpoints } from 'common/constants/KFSEndpoints';
import { Validator } from 'common/validators/validators';
import {
  LoyaltyCustomerDetailResponse,
  LoyaltyDashboardRequest,
  LoyaltyDashboardResponse,
} from 'common/models/LoyaltyTypes';
import { HandleErrorMessage } from '@features/Common';
import { LoyaltyActions } from '../store/LoyaltySlice';

export const GetLoyaltyDashboard = (request: LoyaltyDashboardRequest) => async (dispatch) => {
  const methodName = 'GetLoyaltyDashboard';

  try {
    dispatch(LoyaltyActions.submitStatus());
    const response = await PostData<APIResponse>(KFSEndpoints.Loyalty_GetDashboard, request);
    new Validator(response.parsedBody?.Status).IsEqualsString(APIResponseCode.SUCCESS);
    const data: LoyaltyDashboardResponse = response.parsedBody?.Results;
    dispatch(LoyaltyActions.SetDashboard(data));
    dispatch(LoyaltyActions.submitStatusSucceeded());
    return data;
  } catch (e) {
    dispatch(LoyaltyActions.submitStatusRejected(HandleErrorMessage(methodName, e)));
    notification.error(GetNotificationProps(MessageDisplay.GENERIC_TECHNICAL_ERROR));
    return undefined;
  }
};

export const GetLoyaltyCustomerDetail = (customerKey: string) => async (dispatch, getState) => {
  const methodName = 'GetLoyaltyCustomerDetail';
  // Security review LOW: a slow response for customer A must not land after B was clicked.
  const isStillSelected = () => getState().Loyalty?.SelectedCustomerKey === customerKey;

  try {
    dispatch(LoyaltyActions.submitStatus());
    // Sent as a JSON string body ([FromBody] string customerKey), never in the URL.
    const response = await PostData<APIResponse>(KFSEndpoints.Loyalty_GetCustomerDetail, customerKey);
    new Validator(response.parsedBody?.Status).IsEqualsString(APIResponseCode.SUCCESS);
    const data: LoyaltyCustomerDetailResponse = response.parsedBody?.Results;
    if (!isStillSelected()) return undefined;
    dispatch(LoyaltyActions.SetCustomerDetail(data));
    dispatch(LoyaltyActions.submitStatusSucceeded());
    return data;
  } catch (e) {
    if (!isStillSelected()) return undefined;
    dispatch(LoyaltyActions.submitStatusRejected(HandleErrorMessage(methodName, e)));
    notification.error(GetNotificationProps(MessageDisplay.GENERIC_TECHNICAL_ERROR));
    return undefined;
  }
};
